import * as jQuery from "jquery";
const $ = jQuery.default;

// ===================================================
// Trail Google maps
// ===================================================
$(document).ready(function initialize() {

	var bounds = new google.maps.LatLngBounds();

	var mapOptions = {
		scrollwheel: false,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		styles: [{
				"elementType": "geometry",
				"stylers": [{
					"color": "#f5f5f5"
				}]
			},
			{
				"elementType": "labels.icon",
				"stylers": [{
					"visibility": "off"
				}]
			},
			{
				"elementType": "labels.text.fill",
				"stylers": [{
					"color": "#616161"
				}]
			},
			{
				"elementType": "labels.text.stroke",
				"stylers": [{
					"color": "#f5f5f5"
				}]
			},
			{
				"featureType": "administrative.land_parcel",
				"elementType": "labels.text.fill",
				"stylers": [{
					"color": "#bdbdbd"
				}]
			},
			{
				"featureType": "poi",
				"elementType": "geometry",
				"stylers": [{
					"color": "#eeeeee"
				}]
			},
			{
				"featureType": "poi",
				"elementType": "labels.text.fill",
				"stylers": [{
					"color": "#757575"
				}]
			},
			{
				"featureType": "poi.park",
				"elementType": "geometry",
				"stylers": [{
					"color": "#e5e5e5"
				}]
			},
			{
				"featureType": "poi.park",
				"elementType": "labels.text.fill",
				"stylers": [{
					"color": "#9e9e9e"
				}]
			},
			{
				"featureType": "road",
				"elementType": "geometry",
				"stylers": [{
					"color": "#ffffff"
				}]
			},
			{
				"featureType": "road.arterial",
				"elementType": "labels.text.fill",
				"stylers": [{
					"color": "#757575"
				}]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry",
				"stylers": [{
					"color": "#dadada"
				}]
			},
			{
				"featureType": "road.highway",
				"elementType": "labels.text.fill",
				"stylers": [{
					"color": "#616161"
				}]
			},
			{
				"featureType": "road.local",
				"elementType": "labels.text.fill",
				"stylers": [{
					"color": "#9e9e9e"
				}]
			},
			{
				"featureType": "transit.line",
				"elementType": "geometry",
				"stylers": [{
					"color": "#e5e5e5"
				}]
			},
			{
				"featureType": "transit.station",
				"elementType": "geometry",
				"stylers": [{
					"color": "#eeeeee"
				}]
			},
			{
				"featureType": "water",
				"elementType": "geometry",
				"stylers": [{
					"color": "#c9c9c9"
				}]
			},
			{
				"featureType": "water",
				"elementType": "labels.text.fill",
				"stylers": [{
					"color": "#9e9e9e"
				}]
			}
		]
	};

	var map = new google.maps.Map(document.getElementById("trails-map-canvas"), mapOptions);

	var infoWindow = new google.maps.InfoWindow({
		maxWidth: 300
	});

	$('.panel-map').on('click touchend', function (event, tab) {
		setTimeout(initialize, 300);
	});

	$.each(markers, function (index, data) {
		var iconInactive = "/images/icon-marker.png";
		var iconActive = "/images/icon-marker-hover.png";

		var marker = new google.maps.Marker({
			map: map,
			position: new google.maps.LatLng(data.lat, data.long),
			icon: iconInactive
		});

		bounds.extend(new google.maps.LatLng(data.lat, data.long));
		map.fitBounds(bounds);

		(function (marker, data) {

			var markerId = data.ID

			var markerString = '';

			if (data.title) {
				markerString += '<div><strong>' + data.title + '</strong></div>'
			}

			if (data.image) {
				markerString += '<div><img src="' + data.image + '" alt="' + data.title + '"></div>'
			}

			if (data.content) {
				markerString += '<div><small>' + data.content + '</small></div>'
			}

			// Attaching a click event to the current marker
			google.maps.event.addListener(marker, "click", function (e) {
				if (markerId != '0') {
					var target = $('#' + markerId);
					$('html, body').animate({
						scrollTop: target.offset().top
					}, 1000, function () {
						// Callback after animation
						// Must change focus!
						var $target = $(target);
						$target.focus();
						if ($target.is(":focus")) { // Checking if the target was focused
							return false;
						} else {
							$target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
							$target.focus(); // Set focus again
						};
					});
				} else {
					infoWindow.setContent(markerString);
					infoWindow.open(map, marker);
				}
			});

			google.maps.event.addListener(marker, 'mouseover', function () {
				marker.setIcon(iconActive);
			});
			google.maps.event.addListener(marker, 'mouseout', function () {
				marker.setIcon(iconInactive);
			});

		})(marker, data);
	});

});
